import { Dispatch } from 'redux'

export const CLEAR_TRANSFER_DETAILS = 'CLEAR_TRANSFER_DETAILS'

export const clearTransferDetails = (dispatch: Dispatch) => {
  dispatch({ type: CLEAR_TRANSFER_DETAILS })
}
